// Redesigned Portfolio - Modern, Clean, Anti-Mainstream
// Inspired by Vercel, Linear, and Stripe aesthetics
// Built with React, Three.js, Tailwind CSS, and Framer Motion

import AppRedesign from './AppRedesign';

const App = () => {
  return <AppRedesign />;
};

export default App;
